import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AUTHGWCONSTANTS } from '../authconstatnts';
@Injectable({
  providedIn: 'root',
})
export class OtpService {

  public static dialogResult = false;
  headers: any;

  constructor(private http: HttpClient) { }

  updateHeaders(): boolean {
    try {
      const xenAuth = localStorage.getItem(AUTHGWCONSTANTS.xenAuth);
      this.headers = {
        'XEN-AUTHORIZATION': xenAuth,
      };
      return true;
    } catch {
      return false;
    }
  }

  putSentOtp(body: any): Observable<any> {
    return this.http.put<any>(environment.proxyApiUrl + '/api/auth/user/sign_in', body, {});
  }

  getAddress(): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl + '/api/resource/address/v3', {
      headers: this.headers,
    });
  }

  getServiceArea(urlParams: any): Observable<any> {
    return this.http.get<any>(environment.proxyApiUrl +
      '/api/service/area/selection', {
      headers: this.headers,
      params: urlParams
    });
  }
}
